import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicConsulting() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="66909" id="the-operating-model" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-background/80 bg-[radial-gradient(circle_at_center,_transparent_0%,_hsl(var(--background))_100%)] z-10" />
        <div className="w-full h-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/modern_boardroom_meeting.png)] bg-cover bg-center bg-no-repeat" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="text-4xl md:text-6xl lg:text-8xl font-bold text-primary tracking-tighter mb-6 max-w-5xl drop-shadow-2xl font-default uppercase">
          The Sovereign Operating System
        </h1>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mb-10 leading-relaxed font-sans">
          A disciplined framework for identification, acquisition, and optimization. We unify modern software ventures and digital infrastructure under a single high-authority operating umbrella.
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <Button asChild variant="outline" size="lg" className="border-primary text-primary-foreground bg-primary hover:bg-primary/90 transition-colors duration-300 min-w-[220px] h-14 text-base rounded-none font-default uppercase tracking-widest shadow-xl">
            <Link to="#">
              Explore Holdings
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}